<template>
	<main :style="backgroundImageStyle">
		<ClientOnly>
			<noscript v-if="gtmId">
				<iframe
					:src="gtmSrc"
					height="0"
					width="0"
					style="display: none; visibility: hidden"
				>
				</iframe>
			</noscript>
		</ClientOnly>
		<Loading v-if="store && store.isLoading"></Loading>
		<NuxtPwaManifest />
		<slot />
	</main>
</template>

<script setup>
const store = useAppStore();
const gtmId = useRuntimeConfig()?.public?.gtm;
const gtmSrc = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
const config = useRuntimeConfig();
const backgroundImageStyle = computed(() => {
	const name = config?.public?.showName || "default";
	return `background-image: url('/app-background-${name}.jpg')`;
});
</script>

<style lang="scss">
main {
	min-height: 100vh;
	min-height: 100dvh;
	overflow: hidden;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}
</style>
